import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-slideshow',
  templateUrl: './slideshow.component.html',
  styleUrls: ['./slideshow.component.scss'],
  animations: [
    trigger('blur', [
      transition('false=>true', [
        style({ opacity: 0 }),
        animate('150ms', style({ filter: 'blur(0)', opacity: 1 })),
      ]),
      transition('true=>false', [
        animate('10ms', style({ filter: 'blur(1.5em)', opacity: 0 })),
      ]),
    ]),
  ],
})
export class SlideshowComponent implements OnInit {
  @Input() inputArray: any[];
  @Output() focusedElement: EventEmitter<any> = new EventEmitter();

  transitionState: boolean = false;
  currentElement: number = 0;
  stepperIds: number[];

  ngOnInit(): void {
    this.stepperIds = Array.from(Array(this.inputArray.length).keys());
  }

  public navigateLeft(): void {
    if (this.currentElement > 0) {
      this.transitionState = false;
      setTimeout(() => {
        this.currentElement -= 1;
        this.focusedElement.emit(this.inputArray[this.currentElement]);
      }, 50);
    }
  }

  public navigateRight(): void {
    if (this.currentElement < this.inputArray.length - 1) {
      this.transitionState = false;
      setTimeout(() => {
        this.currentElement += 1;
        this.focusedElement.emit(this.inputArray[this.currentElement]);
      }, 50);
    }
  }
}
